import { useDispatch } from 'react-redux';
import type { AppDispatch } from '@/redux/common/store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
